<div class="form-field">
  @if (name) {
    <span class="label" [class.bold]="bold">{{name}}</span>
  }
  <div
    class="container"
    [class.horizontal]="horizontal"
    >
    @for (itemValue of values; track itemValue) {
      <label [class.reverse]="reverse">
        <span class="app-radiobox">
          <input type="radio" [value]="value(itemValue)" [name]="name" [formControl]="control">
          <span class="inner"></span>
        </span>
        <span>{{ display(itemValue) }}</span>
      </label>
    }
  </div>
</div>
